import React from 'react';

export const ListTooltip = React.memo(({ items, getKey, renderItem }) => {
  if (!items || !Array.isArray(items) || items.length === 0) {
    return null;
  }

  const keyFn = getKey || ((item, index) => index);
  const renderFn = renderItem || ((item) => item);

  return (
    <div>
      {items.map((item, index) => (
        <p key={keyFn(item, index)}>{renderFn(item)}</p>
      ))}
    </div>
  );
});

